import { Dispatch, AnyAction } from 'redux';
import { AbstractStrategy } from './abstract-strategy';

export class ReadyStrategy extends AbstractStrategy {
  execute(dispatch: Dispatch<AnyAction>): void {
    console.log('Executing PostMessage "ReadyStrategy"');
  }
}
